export enum DriverLicenseTypeEnum {
  CLASS_A = 'A',
  CLASS_B = 'B',
  CLASS_C = 'C',
  CLASS_D = 'D',
  CLASS_E = 'E',
  CLASS_M = 'M',
  NON_CDL = 'NON_CDL',
}
